/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const GET_POS_BUSY_HOURS = gql`
  query GetPosBusyHours($filters: PosBusyHourFilter!) {
    posBusyHours(filters: $filters) {
      hour
      quantity
      storeId
    }
  }
`
